import FeedbackEndOfTherapyThankYouModule from './FeedbackEndOfTherapyThankYouModule'

export default FeedbackEndOfTherapyThankYouModule
